import React from 'react';
import { motion } from 'framer-motion';
import { Button, NeuralBackground } from './ui';
export const OfferHero = () => {
  return <section className="relative min-h-[90vh] flex items-center bg-hero-gradient overflow-hidden" data-id="element-109">
      <NeuralBackground data-id="element-110" />
      {/* Decorative large circle */}
      <div className="absolute top-[-10%] right-[-5%] w-[600px] h-[600px] rounded-full bg-purple/20 blur-[100px] pointer-events-none" data-id="element-111" />
      <div className="container mx-auto px-6 relative z-10 py-20" data-id="element-112">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-113">
          {/* Image - shows on top on mobile, right side on desktop */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2
        }} className="relative h-[300px] lg:h-[600px] flex justify-center order-first lg:order-last" data-id="element-114">
            {/* Image with premium dark overlay aesthetic */}
            <div className="relative w-[240px] lg:w-[380px] h-full bg-navy-card border border-gold/20 overflow-hidden" data-id="element-115">
              <div className="absolute inset-0 bg-gradient-to-t from-navy via-transparent to-transparent z-10" data-id="element-116" />
              <img src="https://cdn.magicpatterns.com/uploads/tt1kHACWj4sW35yoUFmuwi/poza_1.png" alt="Marius Cernea" className="w-full h-full object-cover object-center opacity-90" data-id="element-117" />
            </div>
            {/* Decorative elements around image */}
            <div className="absolute bottom-[-24px] left-[calc(50%-120px-24px)] lg:left-[calc(50%-190px-24px)] w-20 lg:w-32 h-20 lg:h-32 border-l border-b border-gold/50" data-id="element-118" />
            <div className="absolute top-[-24px] right-[calc(50%-120px-24px)] lg:right-[calc(50%-190px-24px)] w-20 lg:w-32 h-20 lg:h-32 border-r border-t border-gold/50" data-id="element-119" />
          </motion.div>
          {/* Badge - mobile only, between image and title */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.1
        }} className="lg:hidden flex justify-center order-2" data-id="element-120">
            <div className="inline-block border border-gold/30 px-4 py-1.5 bg-navy/50 backdrop-blur-sm" data-id="element-121">
              <span className="font-display text-gold text-base font-semibold tracking-widest uppercase" data-id="element-122">
                NLP Practitioner Online, Live
              </span>
            </div>
          </motion.div>
          {/* Text content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="max-w-2xl order-last lg:order-first text-center lg:text-left" data-id="element-123">
            {/* Badge - desktop only */}
            <div className="hidden lg:inline-block border border-gold/30 px-4 py-1.5 mb-6 bg-navy/50 backdrop-blur-sm" data-id="element-124">
              <span className="font-display text-gold text-base font-semibold tracking-widest uppercase" data-id="element-125">
                NLP Practitioner Online, Live
              </span>
            </div>
            <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.1] mb-6" data-id="element-126">
              Transformă-ți viața din interior spre exterior.
              <br data-id="element-127" />
              Pas cu pas, în 7 luni.
            </h1>
            <div className="flex flex-col sm:flex-row items-center lg:items-start justify-center lg:justify-start gap-6 mt-10" data-id="element-128">
              <Button data-id="element-129">Scrie-mi pe WhatsApp pentru detalii!</Button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};